import api from './../libs/api';

export default {

    get: (data) => {
        return new Promise((resolve, reject) => {
          api()
            .get(`/line-of-business`, { params: data })
            .then(({ status, data }) => {
              if (status === 200) resolve(data);
              throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
        });
      },
      

  post: (data) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/line-of-business`, data)
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  put: (id, data) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`/line-of-business/${id}`, data)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  delete: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/line-of-business/${id}`)
        .then(({ status, data }) => {
          if (status === 204) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  

  
}; 